var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Inspecao_Resposta_AnomaliaActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Inspecao_Resposta_AnomaliaModule = class Inspecao_Resposta_AnomaliaModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Inspecao_Resposta_AnomaliaActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Inspecao_Resposta_Anomalia/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Inspecao_Resposta_Anomalia.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Inspecao_Resposta_AnomaliaActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Inspecao_Resposta_Anomalia/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Inspecao_Resposta_AnomaliaActions.POST_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.post("Inspecao_Resposta_Anomalia/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Inspecao_Resposta_AnomaliaActions.PUT_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.put("Inspecao_Resposta_Anomalia/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Inspecao_Resposta_AnomaliaActions.DELETE_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.delete("Inspecao_Resposta_Anomalia/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Inspecao_Resposta_AnomaliaActions.DELETE_RANGE_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.delete("Inspecao_Resposta_Anomalia/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Inspecao_Resposta_AnomaliaActions.FILTER_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.post("Inspecao_Resposta_Anomalia/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Inspecao_Resposta_AnomaliaActions.GET_INSPECAO_RESPOSTA_ANOMALIA]() {
        return new Promise(resolve => {
            rotService.get("Inspecao_Resposta_Anomalia/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Inspecao_Resposta_AnomaliaActions.GETWITHDISABLED_INSPECAO_RESPOSTA_ANOMALIA]() {
        return new Promise(resolve => {
            rotService.get("Inspecao_Resposta_Anomalia/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Inspecao_Resposta_AnomaliaActions.GET_BY_ID_INSPECAO_RESPOSTA_ANOMALIA](data) {
        return new Promise(resolve => {
            rotService.get("Inspecao_Resposta_Anomalia/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Inspecao_Resposta_AnomaliaModule.prototype, _k, null);
Inspecao_Resposta_AnomaliaModule = __decorate([
    Module
], Inspecao_Resposta_AnomaliaModule);
export default Inspecao_Resposta_AnomaliaModule;
//********** COMENTÁRIO GERADO EM: 18/06/2025 09:27:38 **********
//
//import rotService from "@/core/services/rotService";
//import JwtService from "@/core/services/JwtService";
//import { Mutations } from "@/store/enums/StoreEnums";
//import {Inspecao_Resposta_AnomaliaActions} from "@/store/enums/rotEnums";
//import {Module, Action, VuexModule} from "vuex-module-decorators";
//
//
//@Module
//export default class Inspecao_Resposta_AnomaliaModule extends VuexModule {
//    errors = {};
//    isAuthenticated = !!JwtService.getToken();
//    
//	@Action
//    [Inspecao_Resposta_AnomaliaActions.DOWNLOAD_PLANILHA]() {
//        return new Promise((resolve, reject) => {
//            rotService.getFile("Inspecao_Resposta_Anomalia/DownloadPlanilhaModelo")
//                .then((response) => {
//                    const blob = new Blob([response.data], {
//                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//                    });
//
//                    const url = window.URL.createObjectURL(blob);
//                    const link = document.createElement('a');
//                    link.href = url;
//                    link.setAttribute('download', 'Planilha_Modelo_Inspecao_Resposta_Anomalia.xlsx');
//                    document.body.appendChild(link);
//                    link.click();
//                    document.body.removeChild(link);
//
//                    resolve(response);
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors);
//                    } else {
//                        reject("Erro ao baixar a planilha.");
//                    }
//                });
//        });
//    }
//
//	 @Action
//    [Inspecao_Resposta_AnomaliaActions.UPLOAD_PLANILHA](file: File) {
//        const formData = new FormData();
//        formData.append('file', file); // Adiciona o arquivo ao FormData
//
//        return new Promise((resolve, reject) => {
//            rotService.postFile("Inspecao_Resposta_Anomalia/ImportarPlanilha", formData)
//                .then(({ data }) => {
//                    resolve(data); // Sucesso
//                })
//                .catch((error) => {
//                    if (error.response) {
//                        this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
//                        reject(error.response.data.errors); // Rejeita com o erro
//                    } else {
//                        reject("Erro ao enviar a planilha.");
//                    }
//                });
//        });
//    }
//
//    @Action
//    [Inspecao_Resposta_AnomaliaActions.POST_INSPECAO_RESPOSTA_ANOMALIA] (data) {
//        return new Promise(resolve => {
//			rotService.post("Inspecao_Resposta_Anomalia/Post", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//		});
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.PUT_INSPECAO_RESPOSTA_ANOMALIA] (data) {
//        return new Promise(resolve => {
//            rotService.put("Inspecao_Resposta_Anomalia/Put", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.DELETE_INSPECAO_RESPOSTA_ANOMALIA](data) {
//        return new Promise(resolve => {
//            rotService.delete("Inspecao_Resposta_Anomalia/Delete", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.DELETE_RANGE_INSPECAO_RESPOSTA_ANOMALIA](data) {
//        return new Promise(resolve => {
//            rotService.delete("Inspecao_Resposta_Anomalia/DeleteRange", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.FILTER_INSPECAO_RESPOSTA_ANOMALIA](data) {
//        return new Promise(resolve => {
//            rotService.post("Inspecao_Resposta_Anomalia/Filter", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.GET_INSPECAO_RESPOSTA_ANOMALIA]() {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Resposta_Anomalia/Get")
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//    [Inspecao_Resposta_AnomaliaActions.GETWITHDISABLED_INSPECAO_RESPOSTA_ANOMALIA]() {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Resposta_Anomalia/GetWithDisabled")
//				  .then(({ data }) => {
//				resolve(data);
//			})
//                .catch (({ response }) => {
//				this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//	@Action
//	[Inspecao_Resposta_AnomaliaActions.GET_BY_ID_INSPECAO_RESPOSTA_ANOMALIA](data) {
//        return new Promise(resolve => {
//            rotService.get("Inspecao_Resposta_Anomalia/GetById", data)
//				.then(({ data }) => {
//                    resolve(data);
//			})
//                .catch (({ response }) => {
//                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
//			});
//        });
//    }
//
//}
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=Inspecao_Resposta_AnomaliaModule.js.map